<script setup lang="ts">
import { computed } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import Navbar from '@/nav/GbNavbarReka.vue'
import LicenseBanner from '@/nav/LicenseBanner.vue'
import ImpersonationBanner from '@/nav/ImpersonationBanner.vue'
import { getAnalyticsTracker } from '@/tracking/analytics/plugin.ts'
import { useContentProfileStore } from '@/contentprofile/contentprofile.store'
import { storeToRefs } from 'pinia'
import LoginModal from '@/authentication/LoginModal.vue'
import PremiumActionModal from '@/components/PremiumActionModal.vue'
import Appcues from '@/components/Appcues.vue'
import { showPremiumActionModal } from '@/router/auth_guards'
import SubmitFeedback from '@/components/SubmitFeedback.vue'
import { provideRouteFeedbackContext } from '@/components/useUserFeedbackContext'

const contentProfileStore = useContentProfileStore()
const { profileId } = storeToRefs(contentProfileStore)
const route = useRoute()
const routeName = computed(() => route.name)

getAnalyticsTracker().getChildContext({
  content_profile_id: profileId,
  page_name: routeName
})

provideRouteFeedbackContext(route)
</script>

<template>
  <a
    href="#main"
    class="sr-only focus:not-sr-only focus:absolute focus:left-2 focus:top-2 focus:z-50 focus:rounded-xs focus:bg-white focus:px-3 focus:py-2 focus:text-text-md focus:text-gray-900"
    >Skip to main content</a
  >
  <ImpersonationBanner />
  <header class="relative flex bg-primary-400 md:justify-center">
    <div class="container">
      <Navbar />
    </div>
  </header>
  <LicenseBanner />
  <main id="main" tabindex="-1">
    <RouterView />
    <LoginModal />
    <PremiumActionModal v-model:external-open="showPremiumActionModal" />
    <Appcues />
    <SubmitFeedback />
  </main>
</template>
